import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { PieChart, Pie, BarChart, Bar, Cell, XAxis, YAxis, Legend } from 'recharts';
import Title from '../../app/orussystem/component/Title';
import { Container, Table, TableBody, TableCell, TableRow } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    rootContainer: {
        display: '1 0 auto',
        borderRadius: '18px',
        background: '#04897C',

    },
    details: {
        display: 'flex',
        flexDirection: 'column',

    },
    content: {
        flex: 1,
        background: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: 0,

    },
    cover: {
        width: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },

}));


const COLORS = ['#95b8f6', '#add5fa', '#f9d99a', '#f9a59a', '#fa5f49', '#4caf50', '#00C49F', '#FFBB28', '#AF19FF'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

const LETTERS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

function getLetter(index) {
    return LETTERS[index % LETTERS.length];
}

export default function PieChartQuetion({ data, title }) {

    const classes = useStyles();

    return (
        <>
            <Title>{title}</Title>
            <Container className={classes.content} style={{ display: 'flex', justifyContent: 'center' }}>
                {data.length > 2 ? (
                    <div>
                        <BarChart
                            width={300}
                            height={150}
                            data={data.map((entry, index) => ({ name: String.fromCharCode(65 + index), value: entry.value }))}
                            margin={{
                                top: 5,
                                right: 50,
                                bottom: 5,
                                left: 5
                            }}
                        >
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Bar dataKey="value" fill="#95b8f6">
                                <Legend />
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % 20]} />
                                ))}
                            </Bar>
                        </BarChart>
                    </div>
                ) : (
                    <div>
                        <PieChart width={250} height={200}>
                            <Pie
                                data={data.map((entry, index) => ({ name: String.fromCharCode(65 + index), value: entry.value }))}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                label={renderCustomizedLabel}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                        </PieChart>
                    </div>
                )}

                <Table size="small" style={{ width: 'auto', margin: '10px 0 0 0' }}>
                    <TableBody>
                        {data.map((row, index) => (
                            <TableRow key={row.value}>
                                <TableCell style={{ backgroundColor: COLORS[index % COLORS.length], fontWeight: 'bold', fontSize: '17px' }} align="left">
                                    {row.name === "Si" || row.name === "No" || row.name === "SI" || row.name === "NO" || row.name === "Sí" || row.name === "SÍ" ? row.name : `(${getLetter(index)}) ${row.name}`}

                                </TableCell>
                                <TableCell style={{ backgroundColor: COLORS[index % COLORS.length], fontSize: "17px", textAlign: 'right' }} align="right">
                                    {row.value}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Container>
        </>

    );
}